angular.module('zc.zenclerkS')
  .controller('ResetPasswordController', ResetPasswordController);

ResetPasswordController.$inject = ['$state', '$stateParams', '$translate', '$window', 'Devise', 'Page'];
function ResetPasswordController($state, $stateParams, $translate, $window, Devise, Page) {
  const vm = this;
  vm.user = {};
  $translate('users.resetPassword.reenterPassword').then(translation => Page.setTitle(translation));

  vm.submit = submit;

  vm.setLanguage = lang => {
    $translate.use(lang);
    $window.document.documentElement.lang = lang;
  };

  function submit(user) {
    Devise.resetPassword($stateParams.reset_password_token, user.password, user.password_confirmation)
      .then(res => Devise.signIn(res.email, user.password, true))
      .then(usr => $window.location.replace($state.href('zenclerkS.home')));
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/users/reset_password/reset_password.controller.js